import React, {useState} from "react";
import html from "react-inner-html";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import {translation} from "../../../../I18n/i18n";
import SpellChecker from "../../../UI/SpellChecker/SpellChecker";

const ProfileOverview = (props) => {
    const [profileOverview, setProfileOverview] = useState (props.element.ProfileOverview.Description ? props.element.ProfileOverview.Description.Label._text : "");
    const [coreSkills, setCoreSkills] = useState (props.element.ProfileOverview.CoreSkills ? props.element.ProfileOverview.CoreSkills.Label._text : "");

    let descriptionSection = (props.element.ProfileOverview.Description.Label._text) ? (
        <div { ...html (translation (props.lang, "Description") + " : " + props.element.ProfileOverview.Description.Label._text) } />
    ) : null
    let coreSkillsSection = (props.element.ProfileOverview.CoreSkills.Label._text) ? (
        <div { ...html (translation (props.lang, "Core skills") + " : " + props.element.ProfileOverview.CoreSkills.Label._text) } />
    ) : null
    return (

        props.hasWriteAccess ? <Aux>
                <SpellChecker freeTextBox
                              multilevelTool
                              dict={ props.dict }
                              notify={ props.notify }
                              addToDictionary={ props.addToDictionary }
                              lang={ props.lang }
                              placeholder={ `${ translation (props.lang, "Description") } ...` }
                              onChange={ v => {
                                  setProfileOverview (v)
                                  props.element.ProfileOverview.Description.Label._text = v
                              } }
                              isDisabled={
                                  !props.isHrMember && !props.isAdminMember && !props.isSalesMember
                              }
                              value={ profileOverview }/>
                <br/>
                <SpellChecker freeTextBox
                              dict={ props.dict }
                              notify={ props.notify }
                              addToDictionary={ props.addToDictionary }
                              lang={ props.lang }
                              placeholder={ `${ translation (props.lang, "Core skills") } ...` }
                              onChange={ v => {
                                  setCoreSkills (v)
                                  props.element.ProfileOverview.CoreSkills.Label._text = v
                              } }
                              isDisabled={
                                  !props.isHrMember && !props.isAdminMember && !props.isSalesMember
                              }
                              value={ coreSkills }/>

            </Aux> :
            <Aux>
                <br/>
                { descriptionSection }
                { coreSkillsSection }
            </Aux>

    )
};

export default ProfileOverview;
